export default "__VITE_ASSET__12c1a8af__"